import styled from "styled-components";

export const ContainerForm = styled.div`
  padding: 20px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  margin-top: 24px;
`;

export const ContainerInstrucoes = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
`;
